import React from 'react';
import './status-indicator.css';

interface StatusIndicatorProps {
  label: string;
  status: 'ONLINE' | 'OFFLINE';
}

export function StatusIndicator({ label, status }: StatusIndicatorProps): React.ReactElement {
  const isOnline = status === 'ONLINE';
  const modifier = isOnline ? 'online' : 'offline';

  return (
    <div className="mc-status">
      <div className="mc-status__dot-wrapper">
        <div className={`mc-status__glow mc-status__glow--${modifier}`} />
        <div className={`mc-status__dot mc-status__dot--${modifier}`} />
      </div>
      <span className="mc-status__label">{label}</span>
      <span className={`mc-status__value mc-status__value--${modifier}`}>{status}</span>
    </div>
  );
}
